import { Check, CircleCheck, Clock, LoaderCircle } from 'lucide-react';

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'waiting':
      return <Clock size={16} className="text-[#272E35]" />;
    case 'doing':
    case 'in_progress':
      return <LoaderCircle size={16} className="animate-spin text-green-600" />;
    case 'done':
    case 'completed':
      return <Check size={16} className="text-green-600" />;
    case 'error':
      return <div className="w-3.5 h-3.5 rounded-full bg-red-500" />;
    default:
      return <Clock size={16} className="text-text-secondary" />;
  }
};

export const getWebSiteDomain = (url: string) => {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
};
